module.exports = __webpack_public_path__ + "static/media/new-tab.d56c6adb.svg";